import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminCurrenciesAPI } from '../services/api';
import './Users.css';

const Currencies = () => {
  const navigate = useNavigate();
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCurrencies = async () => {
    setLoading(true);
    try {
      const response = await adminCurrenciesAPI.getAll();
      setCurrencies(response.data?.currencies || []);
    } catch (error) {
      toast.error('Error loading currencies: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCurrencies();
  }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this currency?')) return;
    try {
      await adminCurrenciesAPI.delete(id);
      toast.success('Currency deleted');
      loadCurrencies();
    } catch (error) {
      toast.error('Error deleting currency: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading && currencies.length === 0) return <div className="loading">Loading currencies...</div>;

  return (
    <div className="users-container">
      <div style={{ marginBottom: 20 }}>
        <button type="button" className="btn btn-primary" onClick={() => navigate('/currencies/new')}>
          + Add Currency
        </button>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Symbol</th>
              <th>Rate to AED</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currencies.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: 20 }}>
                  No currencies found
                </td>
              </tr>
            ) : (
              currencies.map((c) => (
                <tr key={c.id}>
                  <td>{c.code}</td>
                  <td>{c.name}</td>
                  <td>{c.symbol || '-'}</td>
                  <td>{c.rate_to_aed}</td>
                  <td>{c.is_active ? 'Active' : 'Inactive'}</td>
                  <td className="actions">
                    <button type="button" className="btn btn-primary" onClick={() => navigate(`/currencies/${c.id}/edit`)}>
                      Edit
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => remove(c.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Currencies;
